export enum DisplayDealerName {
  YES = "Yes",
  NO = "No",
}

export type PreferenceTableInput = {
  name: string;
  nameKey: string;
  options?: OptionsInput[];
  isLinkedPrefKeyVisible?: boolean;
  isOptionsRadio?: boolean;
  textBoxValue?: string;
  staticValue?: string;
  overrideValue: "Yes" | "No";
  linkedPref?: PreferenceTableInput;
};

export type OptionsInput = {
  name: string;
  isSelected: boolean;
  key: string;
};

export interface Preference<TConfig = Record<string, any>> {
  key: string;
  value: string;
  userOverridable: boolean;
  config?: TConfig | null;
}

export type UpdatedPreference<TConfig = Record<string, any>> = Pick<
  Preference<TConfig>,
  "key"
> &
  Omit<Partial<Preference<TConfig>>, "key" | "value"> & {
    value?: string | null;
  };

export interface MasterPreference<TConfig = Record<string, any>> {
  key: string;
  value: string;
  options: string[];
  level?: string;
  userOverridable?: boolean;
  config?: TConfig | null;
}

export interface Location {
  addressLine1: string;
  addressLine2: string;
  city: string;
  state: string;
  country: string;
  postalCode: string;
  phoneNumber: string;
}

export type ChannelState = {
  enabled: boolean;
  disabledForEdit: boolean;
};

export type AlertPreference = {
  key: string;
  name: string;
  caption?: string;
  channels: {
    email: ChannelState;
    inApp: ChannelState;
  };
};

export type AlertPreferenceGroup = {
  key: string;
  name: string;
  caption?: string;
  childRows: AlertPreference[];
};

export type AlertPreferenceEntry = AlertPreference | AlertPreferenceGroup;

// prettier-ignore
export type PreferenceValueFromApi = {
  channels: {
    email: boolean;
    "in_app": boolean;
  };
};

export type AlertPreferencesFromApi = Record<string, PreferenceValueFromApi>;
export type NotificationPreferencesFromApi = Record<
  string,
  AlertPreferencesFromApi | PreferenceValueFromApi
>;

// prettier-ignore
export type AlertsAndNotificationPreferencesFromApi = {
  "email_addresses": string[];
  "alert_preferences": AlertPreferencesFromApi;
  "notification_preferences": NotificationPreferencesFromApi;
};

export type BulkAlertPreferenceUser = {
  preference: Record<string, { channels: { email: boolean; in_app: boolean } }>;
  email_addresses: string[];
};

export type BulkAlertPreferencesResponse = Record<
  string,
  BulkAlertPreferenceUser
>;
